<!-- File: src/layouts/PreAuthLayout.vue -->
<template>
    <!-- Global Screen Reader Announcer for Accessibility -->
    <div id="sr-announcer" aria-live="polite" aria-atomic="true" class="visually-hidden"></div>

    <main>
        <div class="flex-grow-1">
            <header>
                <nav class="navbar navbar-expand-md navbar-dark bg-dark">
                    <div class="container">
                        <a class="navbar-brand" href="https://cirrusinvicta.com/">
                            <img
                                src="@/assets/logo-white-transparent.svg"
                                width="200"
                                alt="Cirrus Invicta"
                            />
                        </a>
                        <button
                            class="navbar-toggler"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarCollapse"
                            aria-controls="navbarCollapse"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <span class="navbar-toggler-icon"></span>
                        </button>
                        <div class="collapse navbar-collapse" id="navbarCollapse">
                            <ul class="navbar-nav me-auto mb-2 mb-md-0">
                                <li class="nav-item">
                                    <a
                                        class="nav-link active"
                                        aria-current="page"
                                        href="#home"
                                        data-bs-target="#carousel-home"
                                        data-bs-slide-to="0"
                                        >Home</a
                                    >
                                </li>
                                <li class="nav-item">
                                    <a
                                        class="nav-link"
                                        href="#about"
                                        data-bs-target="#carousel-home"
                                        data-bs-slide-to="1"
                                        tabindex="-1"
                                        >About</a
                                    >
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" href="#contact" tabindex="-1">Contact</a>
                                </li>
                                <li class="nav-item">
                                    <a
                                        class="nav-link"
                                        href="#frequently-asked-questions"
                                        data-bs-target="#carousel-home"
                                        data-bs-slide-to="2"
                                        tabindex="-1"
                                        >Frequently Asked Questions</a
                                    >
                                </li>
                            </ul>
                            <div>
                                <a class="btn btn-success" href="https://ui.cirrusinvicta.com/"
                                    >My Account</a
                                >
                            </div>
                        </div>
                    </div>
                </nav>
            </header>

            <video autoplay muted id="my-video">
                <source src="@/assets/video/earth-1.mp4" type="video/webm" />
                Your browser does not support the video tag.
            </video>

            <main class="container">
                <slot></slot>
            </main>
        </div>
        <footer class="copyright w-full small text-center border-t border-grey p-4 pin-b">
            &copy; 2023 Cirrus Invicta. All rights reserved.
        </footer>
    </main>
</template>

<style scoped>
html {
    background: #0a0f1d;
}
body {
    background: transparent;
}

video {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    object-fit: contain;
    overflow-clip-margin: content-box;
    overflow: clip;
    z-index: -1;
}
footer {
    color: white;
}
</style>
